import * as React from "react";
import { Switch, Route, withRouter, RouteComponentProps } from "react-router";
import { inject, observer } from "mobx-react";
import Session from "../../stores/Session";
import { DegreeOfAccess } from "kgt-api/dist/Login";
import AdminScreen from "./Admin";

type Props = RouteComponentProps;

interface InjectedProps extends Props {
  session: Session;
}

@inject("session")
@observer
class AdminRoutes extends React.Component<Props> {
  get injected() {
    return this.props as InjectedProps;
  }

  render() {
    const { match } = this.props;
    const { session } = this.injected;

    return (
      <Switch>
        {session.data &&
          session.data.degreeOfAccess === DegreeOfAccess.Admin && (
              <Route path={`${match.path}`} component={AdminScreen} />
          )}
      </Switch>
    );
  }
}

export default withRouter(AdminRoutes);
